import React, { useState, useEffect } from 'react';
import { Props, Category } from './Accounts.interface';
import './accounts.scss';
import AccountCard from '../../components/AccountCard/AccountCard';
import './accounts.scss';
import { Account } from './Accounts.interface';
import { firestore } from '../../utils/firebase';
import { merge, orderBy } from 'lodash';
import CategoriesList from '../../components/CategoriesList/CategoriesList';
import FiltersPanel, {
  Filtering,
} from '../../components/FiltersPanel/FiltersPanel';
import NoDataView from '../../components/NoDataView/NoDataView';

const Accounts: React.FC<Props> = (props) => {
  const [category, setCategory] = useState<Category>();
  const [accounts, setAccounts] = useState<Account[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const cats: Category[] = JSON.parse(
      localStorage.getItem('categories') || '[]',
    );
    const cat = cats.find((c) => c.id === props.match.params.category);
    setCategory(cat || cats[0]);
  }, [props.match.params.category]);

  useEffect(() => {
    setLoading(true);
    setAccounts([]);
  }, [category]);

  useEffect(() => {
    dbRef()
      .get()
      .then((snapshot) => {
        const data: Account[] = snapshot.docs.map((doc) => {
          return merge(doc.data(), { id: doc.id });
        }) as Account[];

        const ordered = orderBy(data, 'createdAt', 'desc');

        setAccounts(ordered);
        setLoading(false);
      });
  }, [category]);

  const dbRef = () => {
    return firestore
      .collection('accounts')
      .where('categoryId', '==', category?.id || '');
  };

  const filter = (filtering: Filtering) => {
    const { country, city, gender } = filtering.filters;
    const { orderBy: by, orderType } = filtering.order;

    let db = dbRef();

    if (country && country !== 'all') db = db.where('country', '==', country);
    if (country !== 'all' && city !== 'all') db = db.where('city', '==', city);
    if (gender && gender !== 'all') db = db.where('gender', '==', gender);

    db.get().then((snapshot) => {
      const data: Account[] = snapshot.docs.map((doc) => {
        return merge(doc.data(), { id: doc.id });
      }) as Account[];

      const ordered = orderBy(data, by, orderType as 'asc' | 'desc');

      setAccounts(ordered);
      setLoading(false);
    });
  };

  return (
    <>
      <CategoriesList
        selected={category}
        onCategorySelect={(cat) =>
          props.history.push({
            pathname: `/accounts/${cat.id}`,
          })
        }
      />
      {accounts && <FiltersPanel onFiltersSubmit={filter} />}

      {loading && <div>الرجاء الانتظار...</div>}

      {!loading && accounts.length === 0 && <NoDataView />}

      {accounts && (
        <>
          <div className="flex-container">
            {accounts.map((acc) => (
              <AccountCard key={acc.id} category={category!} account={acc} />
            ))}
          </div>
        </>
      )}
    </>
  );
};

export default Accounts;
